const themeActionTypes = {
  SET_THEME: "SET_THEME",
};

export default themeActionTypes;




